import { FC, memo, useState } from 'react';
// Models
import IResult from 'models/Result';
// Utilities
import { buildUserName } from 'utilities/Utilities';

import classes from './styles.module.css';

const Letter:FC<{ letter: string; index: number }> = ({ letter, index }) => {
  const [flip, setFlip] = useState<boolean>(false);

  setTimeout(() => {
    setFlip(true);
  }, 100 * index);

  return (
    <span className={`
      ${flip ? classes.flip : ''}
      ${!letter.trim() ? classes.space : ''}
    `}>
      {flip ? letter : null}
    </span>
  );
}

const Word:FC<{ word: string }> = ({ word }) => (
  <span>
    {Array.from(word).map((letter, index) => (
      <Letter key={index} letter={letter} index={index} />
    ))}
  </span>
)

type Props = {
  result: IResult;
}

const ResultItem:FC<Props> = ({ result }) => {
  return (
    <li
      className="flex pb-2 mb-6 px-4 border-b gap-1 text-white font-medium uppercase sm:text-3xl last:border-none" 
      style={{ borderColor: 'rgba(255,255,255,0.2)' }}
    >
      <div className="flex-1 flex items-center">
        <span className="w-12 sm:w-32">{`${result.position}th`}</span>
        <Word word={buildUserName(result)} />
      </div>
      <div>
        <Word word={`${result.score}`} />
      </div>
    </li>
  );
}

export default memo(ResultItem);
